
<template>
  <div
    class="tw-grid tw-grid-cols-12 tw-rounded-lg tw-border tw-border-neutral-300 tw-items-center"
  >
    <slot />
  </div>
</template>
